// extracted by mini-css-extract-plugin
module.exports = {"container":"PaidPayment_container_2J_LI","footer":"PaidPayment_footer_3ZmgL","contact":"PaidPayment_contact_2-dRA"};